import styled from "styled-components/macro"
import ResidenceInfoCard from "./ResidenceInfoCard"
import FloorplanImage from "@common/components/ResidenceGeneric/FloorplanImage"
import ImageOverlay from "../ImageOverlay"

const FloorplanSection = ({ selectedUnit }) => {
  return (
    <Wrapper id="floorplan">
      <ImageOverlay selectedUnit={selectedUnit} />
      <ResidenceInfoCard unit={selectedUnit} />
      <FloorplanImage unit={selectedUnit} />
    </Wrapper>
  )
}

export default FloorplanSection

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 40% 60%;
  background-color: white;
`
